import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const goDashboard = (res) => {
    if (res.ok) {
      toast.success(res.demo ? "Modo demostración" : "Bienvenido");
      navigate("/app/dashboard");
    } else {
      toast.error(res.error);
    }
  };

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    goDashboard(res);
  };

  const enterDemo = async () => {
    setLoading(true);
    const res = await login("demo@aequor.cl", "Prueba123#");
    setLoading(false);
    goDashboard({ ...res, demo: true });
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2" data-testid="login-page">
      <div className="auth-bg hidden lg:flex relative">
        <div className="absolute inset-0 bg-gradient-to-b from-[#1B4332]/30 via-transparent to-[#1B4332]/60" />
        <div className="relative z-10 p-12 flex flex-col justify-between text-white w-full">
          <div className="flex items-center gap-2">
            <div className="h-8 w-8 rounded-sm bg-white text-[#1B4332] flex items-center justify-center font-display font-bold">
              A
            </div>
            <span className="font-display font-semibold tracking-tight text-lg">Aequor</span>
          </div>
          <div className="space-y-3 max-w-md">
            <div className="label-caps text-white/70">Contabilidad chilena</div>
            <h2 className="font-display text-4xl font-light leading-tight">
              La contabilidad de tu empresa, ordenada y al día.
            </h2>
            <p className="text-white/80 text-sm leading-relaxed">
              Plan de cuentas, libro diario, libro mayor, balance general y estado de resultados.
              Multiempresa, multiusuario.
            </p>
          </div>
        </div>
      </div>

      <div className="flex items-center justify-center p-8 bg-[#F9F8F6]">
        <form
          onSubmit={submit}
          autoComplete="off"
          className="w-full max-w-sm bg-white border border-[#E2DFD8] rounded-md p-8"
          data-testid="login-form"
        >
          <div className="label-caps mb-2">Iniciar sesión</div>
          <h1 className="font-display text-2xl font-medium tracking-tight mb-1">Bienvenido</h1>
          <p className="text-sm text-[#59645E] mb-6">Accede a tu contabilidad.</p>

          <label className="label-caps block mb-1.5" htmlFor="email">Correo</label>
          <input
            id="email"
            name="email"
            type="email"
            required
            autoComplete="off"
            data-testid="login-email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="demo@aequor.cl"
            className="w-full px-3 py-2 rounded-sm border border-[#E2DFD8] bg-white placeholder:text-[#A3ABA6] focus:outline-none focus:ring-2 focus:ring-[#1B4332]/30 focus:border-[#1B4332] text-sm mb-4"
          />

          <label className="label-caps block mb-1.5" htmlFor="password">Contraseña</label>
          <input
            id="password"
            name="password"
            type="password"
            required
            autoComplete="new-password"
            data-testid="login-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Prueba123#"
            className="w-full px-3 py-2 rounded-sm border border-[#E2DFD8] bg-white placeholder:text-[#A3ABA6] focus:outline-none focus:ring-2 focus:ring-[#1B4332]/30 focus:border-[#1B4332] text-sm mb-6"
          />

          <button
            type="submit"
            disabled={loading}
            data-testid="login-submit"
            className="w-full bg-[#1B4332] hover:bg-[#2D6A4F] disabled:opacity-60 text-white text-sm font-medium py-2.5 rounded-sm transition-colors"
          >
            {loading ? "Iniciando…" : "Iniciar sesión"}
          </button>

          <button
            type="button"
            disabled={loading}
            onClick={enterDemo}
            data-testid="login-demo-button"
            className="w-full mt-3 border border-[#1B4332] text-[#1B4332] hover:bg-[#1B4332]/5 disabled:opacity-60 text-sm font-medium py-2.5 rounded-sm transition-colors"
          >
            Ver demostración (solo lectura)
          </button>
        </form>
      </div>
    </div>
  );
}
